<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" class="mb-0">
      <template #prepend>
        <v-icon icon="mdi-home" size="small" />
      </template>
    </v-breadcrumbs>

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card rounded="xl" elevation="2">
            <v-tabs v-model="tab" color="primary" :touch="false" hide-slider="false"  next-icon="mdi-arrow-right-bold-box-outline"
                    prev-icon="mdi-arrow-left-bold-box-outline"
                    show-arrows>
              <v-tab value="permanent" class="font-weight-bold"> স্থায়ী ঠিকানা</v-tab>
              <v-tab value="present" class="font-weight-bold">বর্তমান ঠিকানা</v-tab>
              <v-tab value="emergency" class="font-weight-bold"> জরুরি যোগাযোগের </v-tab>
            </v-tabs>

            <v-divider />
            <v-window v-model="tab">
              <!-- Parents -->
              <v-window-item value="permanent">
                <v-card-text>
                  <PermanentAddress />
                </v-card-text>
              </v-window-item>

              <v-window-item value="present">
                <v-card-text>
                  <PresentAddress />
                </v-card-text>
              </v-window-item>

              <v-window-item value="emergency">
                <v-card-text>
                  <EmergencyContact />
                </v-card-text>
              </v-window-item>

            </v-window>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import PermanentAddress from "@/components/pages/PMIS/AddressInformation/PermanentAddress.vue";
import PresentAddress from "@/components/pages/PMIS/AddressInformation/PresentAddress.vue";
import EmergencyContact from "@/components/pages/PMIS/AddressInformation/EmergencyContact.vue";

export default {
  name: "AddressInformation",

  components: {
    EmergencyContact,
    PresentAddress,
    PermanentAddress

  },

  data() {
    return {
      tab: "permanent",

      /* Breadcrumb */
      breadcrumbs: [
        {
          title: "Dashboard",
          disabled: false,
          to: "/dashboard",
        },
        {
          title: "Address Information",
          disabled: true,
        },
      ],
    };
  },
};
</script>

<style scoped>

</style>
